import { Injectable, NgZone } from '@angular/core';

declare var jQuery: any;
declare var document: any;

@Injectable({
  providedIn: 'root'
})
export class ProfilerCommunicationService {

  private ngZone: NgZone;

  constructor(ngZone: NgZone) {
    this.ngZone = ngZone;
  }

  listen(cb: () => void, thisArg: any) {
    setTimeout(() => {
      jQuery(document).on('oevdigital.profiler.updated', (event: any, data: any) => {
        if (cb) {

          this.ngZone.run(() => {
            cb.call(thisArg);
          });

          // since the profiler widget has no tariff calculation component we have to send a fake completion event
          // to get the profilerwidget to update profile values again

          jQuery(document).trigger('oevdigital.profiler.tariff-computation-completed');
        }
      });
    }, 500);
  }
}
